import { createSlice } from '@reduxjs/toolkit';
import { getOfferDetailsThunk, getOfferListThunk } from '../thunks/offerThunk';


const offerSlice = createSlice({
    name: 'offer',
    initialState: {
        offerList: '',
        offerDetails: ""
    },
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(getOfferListThunk.fulfilled, (state, action) => {
                state.offerList = action.payload?.data;
            })
            .addCase(getOfferDetailsThunk.fulfilled, (state, action) => {
                state.offerDetails = action.payload?.data;
            })
    },
});

// export const {  } = userSlice.actions;

export default offerSlice.reducer;
